module.exports = "<login-page></login-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/login.html
// module id = 1231
// module chunks = 0